import store from '@/store';

export default async (to, from, next) => {
  const isViewas = Boolean(store.state.auth.viewAs);
  const isAdminRoles = store.getters['auth/isAdminOrSales']
    || store.getters['auth/isPromoMaster']
    || store.getters['auth/isSupportAdmin']
    || store.getters['auth/isNotificationsManager'];

  if (isViewas || isAdminRoles) {
    next();
  } else {
    next({ name: 'newapp' });
  }
};
